import React from "react";
import Banner from "./views/home/banner";
import Header from "./views/platform/header";
import Footer from "./views/platform/footer";
import Divider from "./components/atoms/divider";
import HomeTeaser from "./views/home/teaser";

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-light via-white to-primary-light">
      <Header />
      <Banner />
      <Divider />
      <HomeTeaser />
      <Divider />
      <Footer />
    </div>
  );
}

export default App;
